import { Directive, HostBinding, HostListener, inject, input } from '@angular/core';
import { ImagePreviewDialogService } from './image-preview-dialog.service';

@Directive({
  selector: 'ion-img[dojoImagePreview][src], img[dojoImagePreview][src], [dojoImagePreview][src]',
  standalone: true,
  host: {
    '[attr.src]': 'srcUrl()',
  },
  providers: [ImagePreviewDialogService],
})
export class ImagePreviewDirective {
  readonly imagePreviewDialogService: ImagePreviewDialogService = inject(ImagePreviewDialogService);

  readonly srcUrl = input.required<string>({
    // eslint-disable-next-line @angular-eslint/no-input-rename
    alias: 'src',
  });

  readonly buttonOnly = input<boolean>(false);

  @HostBinding('class.cursor-pointer')
  get cursorPointer() {
    return !this.buttonOnly();
  }

  @HostListener('click', ['$event'])
  onImageClick(event: Event) {
    if (!this.buttonOnly()) {
      event.stopPropagation();
      event.preventDefault();
      this.openPreview();
    }
  }

  openPreview() {
    return this.imagePreviewDialogService.openDialog({ input: this.srcUrl() });
  }
}
